import Vuex from 'vuex'

import Mods from '@/store/modules/Mods'
import User from "@/store/modules/User";
import Download from "@/store/modules/Download";
import Notification from '@/store/modules/Notifications'

import type {ModStateType} from "@/store/interfaces/IMods";
import type {DownloadStateType} from "@/store/interfaces/IDownload";
import type {UserStateType} from "@/store/interfaces/IUser";
import type {NotificationStateType} from "@/store/interfaces/INotifications";

interface State {
  mods: ModStateType,
  user: UserStateType,
  download: DownloadStateType,
  notifications: NotificationStateType
}

import createPersistedState from 'vuex-persistedstate'

const dataState = createPersistedState({
  paths: ['download']
})

export default new Vuex.Store<State>({
  modules: {
    mods: Mods,
    user: User,
    download: Download,
    notifications: Notification
  },
  plugins: [dataState]
})
